import { ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { Programs } from "../../models/programsConfig";
import {
  AnyStatusData,
  IdXboxApplicationStep,
  PitchApplicationStep,
  UnsetStatusData,
} from "../../models/status";
import { statusActions, StatusActions } from "../actions/statusActions";
import { StatusScope } from "../scopes";

const initialState: UnsetStatusData = {
  step: {
    [Programs.IdXbox]: IdXboxApplicationStep.Unset,
    [Programs.Pitch]: PitchApplicationStep.Unset,
  },
  isInitialCrmFetchDone: {},
  isSavingForm: false,
  isSubmitting: false,
  isLoadingGameConcept: false,
  currentError: undefined,
  currentProgram: Programs.Unset,
  currentPageType: undefined,
};

export type StatusState = AnyStatusData;

export const updateStep = (
  state: StatusState,
  action: ReturnType<typeof statusActions.updateStep>
): StatusState => ({
  ...state,
  step: {
    ...state.step,
    [action.program]: action.statusStep,
  },
});

export const updateCurrentProgram = (
  state: StatusState,
  action: ReturnType<typeof statusActions.updateCurrentProgram>
): StatusState => ({
  ...state,
  currentProgram: action.program,
});

export const updateCurrentPageType = (
  state: StatusState,
  action: ReturnType<typeof statusActions.updateCurrentPageType>
): StatusState => ({
  ...state,
  currentPageType: action.pageType,
});

export const initialCrmFetchCompleted = (
  state: StatusState,
  action: ReturnType<typeof statusActions.initialCrmFetchCompleted>
): StatusState => {
  if (!action.pageType) {
    return state;
  }
  return {
    ...state,
    isInitialCrmFetchDone: {
      ...state.isInitialCrmFetchDone,
      [action.pageType]: true,
    },
  };
};

export const updateIsSavingForm = (
  state: StatusState,
  action: ReturnType<typeof statusActions.updateIsSavingForm>
): StatusState => ({
  ...state,
  isSavingForm: action.isSavingForm,
});

export const updateIsSubmitting = (
  state: StatusState,
  action: ReturnType<typeof statusActions.updateIsSubmitting>
): StatusState => ({
  ...state,
  isSubmitting: action.isSubmitting,
});

export const updateIsLoadingGameConcept = (
  state: StatusState,
  action: ReturnType<typeof statusActions.updateIsLoadingGameConcept>
): StatusState => ({
  ...state,
  isLoadingGameConcept: action.isLoadingGameConcept,
});

export const updateError = (
  state: StatusState,
  action: ReturnType<typeof statusActions.updateError>
): StatusState => ({
  ...state,
  currentError: action.error,
});

export const statusReducer = withScope(
  [StatusScope],
  new ReducerChain<StatusState>(initialState)
    .on(StatusActions.UPDATE_STEP, updateStep)
    .on(StatusActions.UPDATE_CURRENT_PAGE_TYPE, updateCurrentPageType)
    .on(StatusActions.UPDATE_CURRENT_PROGRAM, updateCurrentProgram)
    .on(StatusActions.INITIAL_CRM_FETCH_COMPLETED, initialCrmFetchCompleted)
    .on(StatusActions.UPDATE_IS_SAVING_FORM, updateIsSavingForm)
    .on(StatusActions.UPDATE_IS_SUBMITTING, updateIsSubmitting)
    .on(StatusActions.UPDATE_IS_LOADING_GAME_CONCEPT, updateIsLoadingGameConcept)
    .on(StatusActions.UPDATE_ERROR, updateError)
    .build()
);
